import { render, staticRenderFns } from "./purchaseDetail.vue?vue&type=template&id=61919f3a&scoped=true"
import script from "./purchaseDetail.vue?vue&type=script&lang=js"
export * from "./purchaseDetail.vue?vue&type=script&lang=js"
import style0 from "./purchaseDetail.vue?vue&type=style&index=0&id=61919f3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61919f3a",
  null
  
)

export default component.exports